import type { Palette } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const pure: Palette['pure'] = {
  dark: '#FFFFFF',
  light: '#000000',
  invisible: 'transparent',
}
